<!--
================================================
Un composant affichant une icone pour sélectionner si un task tr est facturable ou pas

http://localhost:8080/fr/cronocloud-inc/timeTracking
================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>

    <div class="isBillable" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
        <div tabindex="0" id="billableSwitch" class="circle" v-bind:title="$t('facturable')" v-bind:class="{'on':isBillable}"
             v-on:click="toggleIsBillable()" v-on:keypress.enter="toggleIsBillable()">
            <font-awesome-icon class="icon" :icon="['fas', 'dollar-sign']"/>
        </div>
    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../mixins/InterceptorMixin.js";
    // import _ from 'lodash'

    export default {
        name: 'BillableSelectorComp', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin],
        // components: {},


        data: function () {
            return {
                locale : this.$route.params.locale,
                isBillable: false, // boolean indiquant si facturable ou non facturable

            }
        },

        computed:{
          ...mapState({
              themeToDisplay: state => state.app.themeToDisplay
          }),

        },



        methods: {

            /**
             * Toggle isBillable
             */
            toggleIsBillable() {
                if(this.isBillable === true){
                    this.isBillable= false
                }
                else{
                    this.isBillable= true
                }

                this.$root.$emit('billable_selector_updated',this.isBillable)

            },

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/


    //////////////////////////////////////////
    // LIGHT THEME ///////////////////////////
    .isBillable{
      cursor: pointer;
      /*margin-left: 0.5rem;*/
      .circle{
        width: 2.2rem;
        height: 2.2rem;
        background: #f4f4f4;
        border-radius: 1.2rem;
        transition: background-color 200ms ease-in-out;

        .icon{
          color: #ccc;
          font-size: 1.2rem;
          margin: 0.3rem auto 0 ;
          &:hover{color:darken(#ccc,5%)}
        }
        &.on{
          background: #e9f4ce !important;
          .icon {
            color:$brandPrimary;

          }
        }
      }

      /////////////////////////////////////////
      // DARK THEME ///////////////////////////
      &.darkMode {

        .circle{
          //background: darken($brandPrimary,20%);
          background: lighten($darkBg,5%);
          .icon{
            color: $darkFieldBg
          }
          &.on{
            background: lighten($darkBg,4%) !important;
            .icon {
              color:$brandPrimary;

            }
          }
        }
      }

    }




</style>
